'use client';

import type { FC } from 'react';
import { Box } from '@packages/shared';
import { ScrollTopButton } from '@packages/modules';

/**
 * Scroll to top button for search pages (MBA, SERP and ZeroResultsPage)
 * */
export const SearchScrollTopButton: FC = () => (
  <Box
    sx={{
      position: 'fixed',
      bottom: '1rem',
      right: '2%',
      zIndex: 'appBar',
    }}
  >
    <ScrollTopButton />
  </Box>
);
